import React from "react";
import { Text, StyleSheet, View, TouchableOpacity } from "react-native";

import AppTheme from "../../../AppTheme";
import fontStyles from "../../../../fonts";

const DEFAULT_AVERAGES = [
  { id: "lifetime", name: "Recent Average", color: AppTheme.DEFAULT_COLOR },
  { id: "atus", name: "United States", color: AppTheme.atusColor },
];

export default function ComparisonAverages({
  averages = {},
  onAverageSelected = () => {},
  selectedAverages = {},
}) {
  const allAverages = DEFAULT_AVERAGES.map((av) => {
    return { ...av, isIncluded: averages[av.id] && !selectedAverages[av.id] };
  });

  return !averages ? null : (
    <View style={styles.container}>
      <Text style={[fontStyles.caption, styles.header]}>Averages</Text>
      {allAverages.map((av, index) => (
        <TouchableOpacity
          key={index}
          style={styles.average}
          onPress={() => onAverageSelected(av.id)}
        >
          <View
            style={[
              styles.dot,
              av.isIncluded
                ? { backgroundColor: av.color || AppTheme.DEFAULT_COLOR }
                : {
                    backgroundColor: "#8B92A1",
                  },
            ]}
          />
          <Text
            style={[
              fontStyles.captionThin,
              !av.isIncluded ? { color: "#8B92A1" } : {},
            ]}
          >
            {av.name}
          </Text>
        </TouchableOpacity>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    minHeight: 98,
    minWidth: 117,
    borderRadius: 4,
    backgroundColor: "#F3F2F1",
    paddingTop: 8,
    marginLeft: "auto",
  },
  header: {
    marginBottom: 4,
    textAlign: "center",
  },
  average: {
    flexDirection: "row",
    alignItems: "center",
    height: 30,
    paddingLeft: 16,
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: 6,
    marginRight: 9,
  },
});
